uic-icon-button {
  --uic-icon-width: var(--uic-icon-dimensions-default);
  --uic-icon-height: var(--uic-icon-dimensions-default);
  box-sizing: border-box;
  display: inline-block;

  &[disabled] {
    pointer-events: none;
  }

  &[selected] > button {
    color: var(--uic-icon-button-color-selected);
  }

  > button {
    --uic-icon-width: var(--uic-icon-dimensions-default);
    --uic-icon-height: var(--uic-icon-dimensions-default);
    align-items: center;
    background-color: var(--uic-color-white);
    border: 0;
    border-radius: 0;
    color: var(--uic-icon-button-color);
    cursor: pointer;

    display: flex;
    height: var(--uic-icon-button-height);
    justify-content: center;
    padding: 0;
    width: var(--uic-icon-button-width);

    @include focus-visible-outline() {
      outline: 2px solid var(--uic-icon-button-color-focus);
      outline-offset: -2px;
    }

    &:hover {
      color: var(--uic-icon-button-color-hover);
    }

    &:active {
      color: var(--uic-icon-button-color-active);
    }

    &:disabled {
      color: var(--uic-icon-button-color-disabled);
    }

    svg {
      height: var(--uic-icon-height);
      width: var(--uic-icon-width);
    }
  }
}

.uic-icon-button--light > button {
  background-color: transparent;
  color: var(--uic-color-white);

  &:hover {
    color: var(--uic-color-blue1);
  }
}
